import { useSelector } from 'react-redux';
import { ApplicationState } from '../store';
import { GetFlag } from '../utils/featureFlag';

const useIsBusinessTypeCG = (): boolean => {
  const businessType = useSelector(
    (state: ApplicationState) => state.user.businessType
  );
  const isManager = useSelector(
    (state: ApplicationState) => state.user.isManager
  );
  const customers = useSelector(
    (state: ApplicationState) => state.customers.customers
  );
  const ordersInputCustomers = useSelector(
    (state: ApplicationState) => state.user.roles.ordersInputCustomers
  );
  const migrationFlag = GetFlag('purchase-migration-brdi-brin');

  if (isManager) return false;
  if (businessType) return Boolean(migrationFlag) && businessType === 'CG';

  const purchaseCustomers = customers.filter((c) =>
    ordersInputCustomers.includes(c.customerId)
  );
  return (
    Boolean(migrationFlag) &&
    purchaseCustomers.length > 0 &&
    purchaseCustomers.every((c) => c.customerType === 'CG')
  );
};

export default useIsBusinessTypeCG;
